import { Flex, FlexMixin, Grid, Popper, Text } from '@zillow/constellation';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled(Grid)`
  ${FlexMixin}
`;

const TextWrapper = styled(Text)`
  ${FlexMixin}
`;

export function HouseholdSection({ title, text, popover, ...rest }) {
  return (
    <Wrapper display="flex" flexDirection="column" alignItems="flex-start" {...rest}>
      <Text fontType={{ default: 'bodySmall', lg: 'body' }} as="h3">
        {title}
      </Text>
      <Flex display="flex" alignItems="center">
        <TextWrapper fontType={{ default: 'h5', lg: 'h4' }} display="inline-flex" alignItems="center">
          {text}
        </TextWrapper>
        {popover ? <Popper triggered={popover} /> : null}
      </Flex>
    </Wrapper>
  );
}

HouseholdSection.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  popover: PropTypes.element,
};

export default styled(HouseholdSection)``;
